import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteEventReminderService } from '@/services/events'
import { eventDetailsQueryKey } from './useEventDetails'

export const useDeleteEventReminder = (agendaId: string, eventId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (reminderId: number) => deleteEventReminderService(agendaId, eventId, reminderId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: eventDetailsQueryKey(agendaId, eventId) })
      queryClient.invalidateQueries({ queryKey: ['calendar'] })
    },
  })
}
